import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useConfig from 'app/hooks/useConfig';
import { Container } from 'app/components';
import { useFontSize } from 'app/context/FontSizeRoute';
import { generateUniqueId } from 'utils';
import { BlockSecondaryWrapper, Copyright, Contacts } from './styles';
import { linkTo } from 'utils';

// const buildMailTo = (email, subject) => `mailto:${email}?subject=${subject}`;

const BlockSecondary = () => {
  const [t] = useTranslation();
  const { fontSize } = useFontSize();
  const {
    routes,
    footer: { copyright },
    // supportInfo: { contactUs },
    showingOptions
  } = useConfig();

  return (
    <BlockSecondaryWrapper>
      <Container>
        <Copyright fontSize={fontSize}>{copyright}</Copyright>

        <Contacts>
          <a className="b-contacts__link" href="javascript:Cookiebot.renew()">
            {t('common.update_cookies')}
          </a>
          {showingOptions?.privacyPolicy &&
            <NavLink to={linkTo(routes.privacy.pattern)} className="b-contacts__link" activeClassName="_active" id={`footer-contacts-link-${generateUniqueId()}`}>
              {t('common.privacy_policy')}
            </NavLink>
          }
          <NavLink to={linkTo(routes.legal.pattern)} className="b-contacts__link" activeClassName="_active" id={`footer-contacts-link-${generateUniqueId()}`}>
            {t('common.legal_info')}
          </NavLink>
          <NavLink
            to={linkTo(routes.impressum.pattern)}
            className="b-contacts__link"
            activeClassName="_active"
            id={`footer-contacts-link-${generateUniqueId()}`}
          >
            {t('common.impressum')}
          </NavLink>

          {/* <a
            href={buildMailTo(contactUs.email, t('footer.contact_us'))}
            className="b-contacts__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('footer.contact_us')}
          </a> */}

          <NavLink to={linkTo(routes.faq.pattern)} className="b-contacts__link" activeClassName="_active" id={`footer-contacts-link-${generateUniqueId()}`}>
            {t('footer.contact_us')}
          </NavLink>
          {
            showingOptions?.advertising && (
              <NavLink to={linkTo(routes.b2b.pattern)} className="b-contacts__link" activeClassName="_active" id={`footer-contacts-link-${generateUniqueId()}`}>
                {t('footer.b2b')}
              </NavLink>
            )}
        </Contacts>
      </Container >
    </BlockSecondaryWrapper >
  );
};

export default BlockSecondary;
